exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #8600b5;\r\n    height: 60px;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/status-bar/status-bar.component.css
// module id = 1869
// module chunks = 1